
/**
 * Valor por defecto para imagen secundaria.
 */
export const defaultDataImage = () => {
  return {
    image: null,
    services: []
  };
};

/**
 * Valor por defecto para servicios.
 */
export const defaultDataServices = () => {
  return [
    {
      title: 'Inventario',
      val: 'inventory'
    },
    {
      title: 'Etiquetas',
      val: 'labels'
    },
    {
      title: 'FDS',
      val: 'fds'
    },
    {
      title: 'Pantalla de inicio',
      val: 'dashboard'
    },
  ];
};

/**
 * Variables
 */
export default {
  imgPreviewPath: null,
  services: defaultDataServices(),
  secondaryImage: defaultDataImage()
};
